/**
 * SEO head and site-search entry of `/about-us/leadership-team`. The page copy itself is in
 * `components/Leadership/LeadershipTeamContent.tsx`.
 */
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { LeadershipTeamHeroContent } from "@components/Leadership/LeadershipTeamContent";

/**
 * Head tags per language, read by `src/pages/about-us/leadership-team/index.tsx`. French and
 * Spanish carry the English title and description. `company: true` adds the Organization JSON-LD.
 */
export const MetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Leadership Team - Ryerson",
		description:
			"The leadership team collectively guides the vision of creating an even better company for tomorrow.",
		url: `/about-us/leadership-team`,
		company: true,
	},
	fr: {
		title: "Leadership Team - Ryerson",
		description:
			"The leadership team collectively guides the vision of creating an even better company for tomorrow.",
		url: `/about-us/leadership-team`,
		company: true,
	},
	es: {
		title: "Leadership Team - Ryerson",
		description:
			"The leadership team collectively guides the vision of creating an even better company for tomorrow.",
		url: `/about-us/leadership-team`,
		company: true,
	},
};

/** The page's entry in `public/search-site.json`, imported by `scripts/staticSearch.ts`. */
export const PageContent: StaticPageContent = {
	meta: MetaObject,
	content: [LeadershipTeamHeroContent],
};
